import Vue from 'vue'
import VueRouter from 'vue-router'
import ComerciosView from '../views/Comercios/ComerciosView.vue'
import CancelarReserva from '../views/Comercios/CancelarReserva.vue'
Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'ComerciosView',
        component: ComerciosView
    },
    {
        path:'/cancelarreserva/:token',
        name:'CancelarReserva',
        component: CancelarReserva,
        meta: {
            requiresAuth: false
        },

    },
]

const router = new VueRouter({    
    mode: 'history',
    base: '/emulsa/comercios/',
    routes: routes
})

export default router
